import React from "react";
import Reports from "../../components/Reports/Reports";

const ReportsContainer = () => {
  return (
    <div className="container_height">
      <Reports />
    </div>
  );
};

export default ReportsContainer;
